export default __webpack_public_path__ + "static/media/Crypto_Voxels.167a092f.png";